import { CategorySelector, Dropdown } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Statistics/Pulse/components/AddCardDropdown/AddCardDropdown.module.scss'
import clsx from 'clsx'

export const AddCardDropdown = ({ metrics = {}, onSelect = () => {} }) => {
  const { t } = useTranslation(['pulse'])
  const [selected, setSelected] = useState([])

  const handleSelect = useCallback(
    (newSelection) => {
      setSelected(newSelection)
      onSelect(newSelection)
    },
    [setSelected, onSelect],
  )

  const handleReset = useCallback(() => {
    onSelect([])
  }, [onSelect])

  const groups = useMemo(
    () =>
      Object.entries(metrics).reduce((acc, [key, value]) => {
        const item = {}
        item.id = key

        if (value && value.children) {
          const label = `chart.legend.labels.${key}.label`
          if (label === t(label)) {
            return
          }
          item.label = t(label)

          item.options = []
          Object.entries(value.children).forEach(([k]) => {
            const label = `chart.legend.labels.${key}.${k}`
            if (label === t(label)) {
              return
            }
            item.options.push({
              id: `${key}.${k}`,
              label: t(label),
            })
          })
        } else {
          const label = `chart.legend.labels.${key}`
          if (label === t(label)) {
            return
          }
          item.label = t(label)
        }

        acc = acc.concat(item)

        return acc
      }, []),
    [metrics],
  )

  return (
    <Dropdown>
      <CategorySelector
        className={clsx(styles['dropdown__scroll'], styles['dropdown__selector'])}
        values={selected}
        groups={groups}
        placeholder={t('chart.add_metric')}
        onSelect={handleSelect}
        onReset={handleReset}
        listTitle={t('chart.add_metric')}
        loading={false}
        i18n={{
          listTitle: t('chart.add_metric'),
          apply: t('common::buttons.apply'),
          dropSelection: t('common::buttons.reset'),
        }}
      />
      {/* <ActionButtons
        className={styles['dropdown__action-button']}
        dropFilter={() => setSelected([])}
        applyValue={() => onSelect(selected)}
        showActionButtons={true}
      />*/}
    </Dropdown>
  )
}

AddCardDropdown.defaultProps = {
  className: '',
  metrics: {},
  onSelect: () => {},
}

AddCardDropdown.propTypes = {
  className: PropTypes.string,
  metrics: PropTypes.object,
  onSelect: PropTypes.func,
}
